import cn from "classnames"

import { Flex } from "@/atoms"
import { isCI } from "@/domain/scan-history"
import { IconTextCell } from "@/molecules/IconTextCell"
import { InformationPopover } from "@/molecules/InformationPopover"
import { ContentResourcesPopover } from "@/molecules/Resources/ContentResourcesPopover"
import { PrCell } from "../PrCell"
import { IconResourceCell } from "./IconResourceCell"

import styles from "./ResourceCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type * as selectors from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"

export const ResourceCell = (props: { t: TFunction }) =>
  function ResourceCellComponent(
    value: string,
    record: ReturnType<
      typeof selectors.getScanHistorySelector
    >["data"][number] & { imageSource?: Image.Source }
  ) {
    const showPrLink = !!record.refId && !!record.refUrl
    const ci = isCI(record)

    return (
      <InformationPopover.Popover
        placement="top"
        content={
          <>
            {!ci && (
              <ContentResourcesPopover
                resources={[
                  {
                    id: record.refId,
                    type: "CodeRepository" as const,
                    sourceControl: record.sourceControl,
                    name: record.resourceScanned,
                    tag: ""
                  }
                ]}
              />
            )}
            {ci && (
              <InformationPopover.CommonTemplate
                classes={{ content: styles.popoverContent }}
                title={IconTextCell({
                  classes: { container: styles.iconTextContainer },
                  icon: <IconResourceCell record={record} />,
                  text: props.t(
                    `governance.scanHistory.resourceType.${record.scanType}`,
                    { defaultValue: "Code Repository" }
                  )
                })}
              >
                <Flex gap={24} align="flex-start">
                  <span className={cn(styles.text, styles.label)}>
                    {props.t("general.description")}
                  </span>
                  <Flex flex={1} className={cn(styles.text, styles.textWrap)}>
                    {record.description || "-"}
                  </Flex>
                </Flex>
              </InformationPopover.CommonTemplate>
            )}
          </>
        }
      >
        <div className={styles.wrapper}>
          <IconTextCell
            noTooltip
            variant="regular"
            icon={<IconResourceCell record={record} className={styles.icon} />}
            text={value}
            description={
              <Flex align="center" gap={4}>
                <span>Ref ID:</span>
                {showPrLink && PrCell(record.refId, record)}
                {!showPrLink && <span>{record.refId || "-"}</span>}
              </Flex>
            }
          />
        </div>
      </InformationPopover.Popover>
    )
  }
